import styled, { createGlobalStyle } from 'styled-components';
import { Colors, FontSizes, Screens } from 'core/CssVariables';

export const SFaqModalOverride = createGlobalStyle`
  @media (max-width: ${Screens.ScreensMD}) {
    .faq-modal {
      max-width: calc(100vw - 32px);
      margin: 16px auto;
    }
    .faq-modal .ant-modal-body {
      padding: 12px;
    }
  }
`;

export const SFaqWrapper = styled.div`
  display: flex;
  gap: 16px;
  min-height: 400px;

  @media (max-width: ${Screens.ScreensMD}) {
    flex-direction: column;
    min-height: auto;
    gap: 12px;
  }
`;

export const SFaqCategoryList = styled.div`
  width: 200px;
  min-width: 200px;
  border-right: 1px solid ${Colors.LightBorderColor};
  padding-right: 16px;
  max-height: 60vh;
  overflow-y: auto;

  .category-list-title {
    font-size: ${FontSizes.FontSM}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${Colors.LightBorderColor};
  }

  @media (max-width: ${Screens.ScreensMD}) {
    width: 100%;
    min-width: unset;
    border-right: none;
    border-bottom: 1px solid ${Colors.LightBorderColor};
    padding-right: 0;
    padding-bottom: 12px;
    max-height: none;
    overflow-y: visible;
    overflow-x: auto;
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;

    .category-list-title {
      display: none;
    }
  }
`;

export const SFaqCategoryItem = styled.div<{ $isActive?: boolean }>`
  padding: 8px 12px;
  margin-bottom: 4px;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ $isActive }) =>
    $isActive ? Colors.PrimaryColor : 'transparent'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? Colors.PrimaryColor : Colors.LightBackground};

    .title {
      color: ${({ $isActive }) => ($isActive ? Colors.White : Colors.Dark)};
    }
  }

  .title {
    font-size: ${FontSizes.FontSM}px;
    font-weight: 500;
    color: ${({ $isActive, theme }) =>
      $isActive ? Colors.White : theme.color};
  }

  @media (max-width: ${Screens.ScreensMD}) {
    white-space: nowrap;
    margin-bottom: 0;
    flex-shrink: 0;
  }
`;

export const SFaqContent = styled.div`
  flex: 1;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;

  h1 {
    font-size: ${FontSizes.FontXL}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-bottom: 16px;
    border-bottom: 1px solid ${Colors.LightBorderColor};
    padding-bottom: 8px;
  }

  h2 {
    font-size: ${FontSizes.FontLG}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-top: 24px;
    margin-bottom: 12px;
  }

  h3 {
    font-size: ${FontSizes.FontMD}px;
    font-weight: 600;
    color: ${({ theme }) => theme.color};
    margin-top: 16px;
    margin-bottom: 8px;
  }

  p {
    font-size: ${FontSizes.FontSM}px;
    color: ${({ theme }) => theme.color};
    margin-bottom: 12px;
    line-height: 1.6;
  }

  ul,
  ol {
    margin-bottom: 12px;
    padding-left: 24px;
  }

  li {
    font-size: ${FontSizes.FontSM}px;
    color: ${({ theme }) => theme.color};
    margin-bottom: 4px;
    line-height: 1.5;
  }

  strong {
    font-weight: 600;
    color: ${({ theme }) => theme.color};
  }

  code {
    background-color: ${Colors.LightBackground};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: ${FontSizes.FontXS}px;
  }

  pre {
    background-color: ${Colors.LightBackground};
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 12px;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${Colors.LightBorderColor};
    margin: 24px 0;
  }

  @media (max-width: ${Screens.ScreensMD}) {
    max-height: 50vh;
    padding-right: 0;

    h1 {
      font-size: ${FontSizes.FontLG}px;
    }

    h2 {
      font-size: ${FontSizes.FontMD}px;
    }

    h3 {
      font-size: ${FontSizes.FontSM}px;
    }
  }
`;

export const SLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;
